import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { useSelector } from 'react-redux';
import Iconify from '../iconify/Iconify';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const { currentUser } = useSelector(
    state => state.auth.isAuthenticated,
  );
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data
          .filter(
            item =>
              currentUser.role === 'super_admin' ||
              item.itemRole !== 'super_admin',
          )
          .map(item => (
            <NavItem key={item.title} item={item} />
          ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      {icon && (
        <StyledNavItemIcon>
          <Iconify icon={icon} color="#078DEE" />
        </StyledNavItemIcon>
      )}

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
